var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.gridApi
    ? _c("div", { staticClass: "order-filter-manager" }, [
        _c("div", { staticClass: "row" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Saved filters")]),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedId,
                  expression: "selectedId",
                },
              ],
              staticClass: "select",
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedId = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.onSelectChange,
                ],
              },
            },
            [
              _c("option", { domProps: { value: null } }, [_vm._v("None")]),
              _vm._l(_vm.filters, function (f) {
                return _c(
                  "option",
                  {
                    key: f.userSavedGridSearchId,
                    domProps: { value: f.userSavedGridSearchId },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(f.shouldApplyByDefault ? "⭐ " : "") +
                        _vm._s(f.name) +
                        "\n            "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
          _c(
            "button",
            {
              staticClass: "btn",
              attrs: { disabled: !_vm.hasGridState },
              on: { click: _vm.saveAsNew },
            },
            [_vm._v("Save as new")]
          ),
          _c(
            "button",
            {
              staticClass: "btn",
              attrs: { disabled: !_vm.currentFilter || !_vm.hasGridState },
              on: { click: _vm.saveCurrent },
            },
            [_vm._v("Save")]
          ),
          _c(
            "button",
            {
              staticClass: "btn",
              attrs: { disabled: !_vm.currentFilter },
              on: { click: _vm.startRename },
            },
            [_vm._v("Rename")]
          ),
          _c(
            "button",
            {
              staticClass: "btn danger",
              attrs: { disabled: !_vm.currentFilter },
              on: { click: _vm.deleteCurrent },
            },
            [_vm._v("Delete")]
          ),
          _vm.currentFilter
            ? _c(
                "button",
                {
                  staticClass: "btn",
                  attrs: { disabled: !_vm.currentFilter },
                  on: { click: _vm.toggleDefault },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.currentFilter.shouldApplyByDefault
                          ? "Unset default"
                          : "Set as default"
                      ) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm.showNameInput
          ? _c("div", { staticClass: "name-row" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.tempName,
                    expression: "tempName",
                  },
                ],
                staticClass: "name-input",
                attrs: { placeholder: "Filter name" },
                domProps: { value: _vm.tempName },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.confirmName($event)
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.tempName = $event.target.value
                  },
                },
              }),
              _c(
                "button",
                { staticClass: "btn primary", on: { click: _vm.confirmName } },
                [_vm._v("OK")]
              ),
              _c(
                "button",
                { staticClass: "btn", on: { click: _vm.cancelName } },
                [_vm._v("Cancel")]
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }